/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const CRSFFindingSource = {
    Asm: 'asm',
    Firehose: 'firehose',
    External: 'external'
} as const;
export type CRSFFindingSource = typeof CRSFFindingSource[keyof typeof CRSFFindingSource];


export function CRSFFindingSourceFromJSON(json: any): CRSFFindingSource {
    return CRSFFindingSourceFromJSONTyped(json, false);
}

export function CRSFFindingSourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): CRSFFindingSource {
    return json as CRSFFindingSource;
}

export function CRSFFindingSourceToJSON(value?: CRSFFindingSource | null): any {
    return value as any;
}

